import { Button, Stack } from '@mui/material';
import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import Theme, { headingFontBold } from '../../../Theme';
import { fetchDocumentDetails } from '../../../util/ProjectUtils';

/**
 * Component that shows the user an message when an error occurs loading their document's details.
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'docDetailsView' });

    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Access replicaId, idDocIndex data from the URL. */
    const { replicaId, universalId } = useParams();

    /**
     * Triggers a reload of the request for the active document.
     */
    const triggerReload = () => dispatch(fetchDocumentDetails({ replicaId, universalId }));

    return (
        <Stack
            spacing={2}
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                flexGrow: 4,
            }}
        >
            <Stack sx={{ ...headingFontBold, fontSize: 30, color: Theme.palette.error.main }}>
                {t('error')}
            </Stack>
            <Stack sx={{ ...headingFontBold }}>{t('documentDetailsLoadError')}</Stack>
            <Button
                color='error'
                sx={{ ...headingFontBold, textTransform: 'none', px: 2 }}
                onClick={triggerReload}
            >
                {t('reload')}
            </Button>
        </Stack>
    );
};
